import { Outlet } from "react-router-dom";
import PageLayout from "../../components/UI/Layout/PageLayout";

export default function CandidatRootPage() {
  return (
    <PageLayout isTenant>
      <Outlet />
    </PageLayout>
  );
}
